module.exports = __webpack_public_path__ + "img/Multi-account-en-3.8c7a7dfc.png";